import { FieldErrors, FieldPath } from 'react-hook-form'
import i18next from 'i18next'
import some from 'lodash/some'

import {
  TIMELINE_CONFIG_STEPS,
  TIMELINE_GENERAL_FORM_FIELD_KEYS,
  TIMELINE_OBJECT_X_FORM_FIELD_KEYS,
  TIMELINE_OBJECT_Y_FORM_FIELD_KEYS,
} from '@constants'
import { TimeLineGridConfig } from '@types'

export const getIsStepFailed = (stepLabel: string, errors: FieldErrors<TimeLineGridConfig>) => {
  const errorKeys = Object.keys(errors)

  function hasCommonItems(errors: string[], appliedFields: string[]) {
    return some(errors, r => appliedFields.includes(r))
  }

  switch (stepLabel) {
    case TIMELINE_CONFIG_STEPS.GENERAL:
      return hasCommonItems(errorKeys, TIMELINE_GENERAL_FORM_FIELD_KEYS)
    case TIMELINE_CONFIG_STEPS.OBJECT_Y:
      return hasCommonItems(errorKeys, TIMELINE_OBJECT_Y_FORM_FIELD_KEYS)
    case TIMELINE_CONFIG_STEPS.OBJECT_X:
      return hasCommonItems(errorKeys, TIMELINE_OBJECT_X_FORM_FIELD_KEYS)
    default:
      return false
  }
}

export const getStepErrorFields = (stepLabel: string, errors: FieldErrors<TimeLineGridConfig>) => {
  const errorKeys = Object.keys(errors) as Array<FieldPath<TimeLineGridConfig>>

  const objectXErrors = Object.keys(errors.objectX || {}).filter(
    item => item !== 'cell' && item !== 'totalsRows'
  )
  const objectXCellErrors = Object.keys(errors.objectX?.cell || {}).map(item =>
    i18next.t(`timeLinesCreateOrEdit.objectX.stepFieldErrors.cell.${item}`)
  )
  const objectXTotalsRowsErrors =
    errors?.objectX?.totalsRows?.map?.(
      (_, index) =>
        `${i18next.t('timeLinesCreateOrEdit.objectX.stepFieldErrors.totals.row')} ${index + 1}`
    ) || []
  const objectYErrors = Object.keys(errors.objectY || {})

  switch (stepLabel) {
    case TIMELINE_CONFIG_STEPS.GENERAL:
      return errorKeys
        .filter(element => TIMELINE_GENERAL_FORM_FIELD_KEYS.includes(element))
        .map(item => i18next.t(`timeLinesCreateOrEdit.general.stepFieldErrors.${item}`))
    case TIMELINE_CONFIG_STEPS.OBJECT_Y:
      return objectYErrors.map(item =>
        i18next.t(`timeLinesCreateOrEdit.objectY.stepFieldErrors.${item}`)
      )
    case TIMELINE_CONFIG_STEPS.OBJECT_X:
      return objectXErrors
        .map(item => i18next.t(`timeLinesCreateOrEdit.objectX.stepFieldErrors.${item}`))
        .concat(objectXCellErrors)
        .concat(objectXTotalsRowsErrors)
    default:
      return []
  }
}
